// prettier-ignore
const ALL = [
  { id: 1, min: 4, max: 4,     name: 'mighty_mite_1', 'pt-BR': 'Pré-mirim 1',       'en-US': 'Mighty-mite 1' },
  { id: 2, min: 5, max: 5,     name: 'mighty_mite_2', 'pt-BR': 'Pré-mirim 2',       'en-US': 'Mighty-mite 2' },
  { id: 3, min: 6, max: 6,     name: 'mighty_mite_3', 'pt-BR': 'Pré-mirim 3',       'en-US': 'Mighty-mite 3' },
  { id: 4, min: 7, max: 7,     name: 'pee_wee_1',     'pt-BR': 'Mirim 1',           'en-US': 'Pee-Wee 1' },
  { id: 5, min: 8, max: 8,     name: 'pee_wee_2',     'pt-BR': 'Mirim 2',           'en-US': 'Pee-Wee 2' },
  { id: 6, min: 9, max: 9,     name: 'pee_wee_3',     'pt-BR': 'Mirim 3',           'en-US': 'Pee-Wee 3' },
  { id: 7, min: 10, max: 10,   name: 'junior_1',      'pt-BR': 'Infantil 1',        'en-US': 'Junior 1' },
  { id: 8, min: 11, max: 11,   name: 'junior_2',      'pt-BR': 'Infantil 2',        'en-US': 'Junior 2' },
  { id: 9, min: 12, max: 12,   name: 'junior_3',      'pt-BR': 'Infantil 3',        'en-US': 'Junior 3' },
  { id: 10, min: 13, max: 13,  name: 'teen_1',        'pt-BR': 'Infanto Juvenil 1', 'en-US': 'Teen 1' },
  { id: 11, min: 14, max: 14,  name: 'teen_2',        'pt-BR': 'Infanto Juvenil 2', 'en-US': 'Teen 2' },
  { id: 12, min: 15, max: 15,  name: 'teen_3',        'pt-BR': 'Infanto Juvenil 3', 'en-US': 'Teen 3' },
  { id: 13, min: 16, max: 16,  name: 'juvenile_1',    'pt-BR': 'Juvenil 1',         'en-US': 'Juvenile 1' },
  { id: 14, min: 17, max: 17,  name: 'juvenile_2',    'pt-BR': 'Juvenil 2',         'en-US': 'Juvenile 2' },
  { id: 15, min: 18, max: 999, name: 'adult',         'pt-BR': 'Adulto',            'en-US': 'Adult' },
  { id: 16, min: 30, max: 999, name: 'master_1',      'pt-BR': 'Master 1',          'en-US': 'Master 1' },
  { id: 17, min: 36, max: 999, name: 'master_2',      'pt-BR': 'Master 2',          'en-US': 'Master 2' },
  { id: 18, min: 41, max: 999, name: 'master_3',      'pt-BR': 'Master 3',          'en-US': 'Master 3' },
  { id: 19, min: 46, max: 999, name: 'master_4',      'pt-BR': 'Master 4',          'en-US': 'Master 4' },
  { id: 20, min: 51, max: 999, name: 'master_5',      'pt-BR': 'Master 5',          'en-US': 'Master 5' },
  { id: 21, min: 56, max: 999, name: 'master_6',      'pt-BR': 'Master 6',          'en-US': 'Master 6' },
  { id: 23, min: 16, max: 17,  name: 'juvenile',      'pt-BR': 'Juvenil',           'en-US': 'Juvenile' },
  { id: 24, min: 4, max: 6,    name: 'mighty_mite',   'pt-BR': 'Pré-mirim',         'en-US': 'Mighty-mite' },
  { id: 25, min: 7, max: 9,    name: 'pee_wee',       'pt-BR': 'Mirim',             'en-US': 'Pee-Wee' },
  { id: 26, min: 10, max: 12,  name: 'junior',        'pt-BR': 'Infantil',          'en-US': 'Junior' },
  { id: 27, min: 13, max: 15,  name: 'teen',          'pt-BR': 'Infanto Juvenil',   'en-US': 'Teen' },
  { id: 28, min: 61, max: 999, name: 'master_7',      'pt-BR': 'Master 7',          'en-US': 'Master 7' },
  { id: 29, min: 66, max: 999, name: 'master_8',      'pt-BR': 'Master 8',          'en-US': 'Master 8' }
]

// Kids é RANGE DE IDADE, não atributo da divisão: nas 27 linhas de `AgeDivision` toda a faixa que o
// legado marca como Child tem `max <= 15` (as agrupadas — Pré-mirim 4-6, Mirim 7-9, Infantil 10-12,
// Infanto Juvenil 13-15 — caem no mesmo lugar pela idade). Então a classificação é derivada daqui, e
// não uma coluna espelhada do enum legado que o catálogo carregaria para sempre.
const KIDS_MAX_AGE = 15

export function kidsIds() {
  return ALL.filter(division => division.max <= KIDS_MAX_AGE).map(division => division.id)
}

export function all() {
  return [...ALL]
}

export function findById(id) {
  return ALL.find(division => division.id === +id)
}

export function findByName(name) {
  return ALL.find(division => division.name === name)
}
